"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[75827],{

/***/ 536430:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(327723);
var icons = __webpack_require__(225956);
var grid = __webpack_require__(793767);
var Container = __webpack_require__(739890);
var Slider = __webpack_require__(699332);
var getStyles = __webpack_require__(523340);
var BlockHeader = __webpack_require__(177530);
var renderLink = __webpack_require__(62534);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const { cardDefaultImage: defaultImage } = coreRenderer.mappingAssets;
const RecommendBrand = (_a) => {
  var _b = _a, {
    isEditingMode
  } = _b, restProps = __objRest(_b, [
    "isEditingMode"
  ]);
  var _c;
  const { device } = coreRenderer.useStore();
  const isDesktop = device === "desktop";
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), {
    commonStyle,
    title,
    titleStyle,
    altStyle,
    showAlt = true,
    items,
    autoSwipeTimeMilliseconds,
    viewMoreUrl,
    showDescription,
    descriptionStyle,
    viewMoreStyle,
    maxWidth = grid.DEFAULT_MAX_WIDTH
  } = _a2, rest = __objRest(_a2, [
    "commonStyle",
    "title",
    "titleStyle",
    "altStyle",
    "showAlt",
    "items",
    "autoSwipeTimeMilliseconds",
    "viewMoreUrl",
    "showDescription",
    "descriptionStyle",
    "viewMoreStyle",
    "maxWidth"
  ]);
  const { displayItems } = coreRenderer.useTimeVisibility(items, isEditingMode);
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  const renderBrandItem = (item, index) => {
    const { event, googleImageParams, src, alt, description } = item;
    const content = /* @__PURE__ */ jsxRuntime.jsxs(BrandItem, {
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(ImageWrapper, {
          children: /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, __spreadValues({
            googleImageParams,
            src: src || defaultImage,
            alt: alt || "Brand",
            isEditingMode,
            commonStyle: __spreadValues({
              width: "100%",
              borderRadius: 8,
              objectFit: "cover"
            }, isDesktop ? {
              height: "140px",
              hover: { zoom: 103 }
            } : {
              height: "120px"
            })
          }, !isEditingMode && coreRenderer.getTrackingData({
            isTrackContent: true,
            regionName: "topBrands",
            contentName: alt,
            index,
            target: coreRenderer.getTargetOfTrackingFromEvent(event)
          })))
        }),
        showDescription && !!description && /* @__PURE__ */ jsxRuntime.jsx(BrandDescription, {
          commonStyle: descriptionStyle,
          children: description
        }),
        showAlt && /* @__PURE__ */ jsxRuntime.jsx(BrandTitle, {
          commonStyle: altStyle,
          children: alt
        })
      ]
    });
    return renderLink.renderLink(event, content, isEditingMode, index);
  };
  const renderViewAllLink = () => {
    if (!viewMoreUrl)
      return null;
    const content = /* @__PURE__ */ jsxRuntime.jsxs(ViewAll, {
      commonStyle: viewMoreStyle,
      children: [
        "Xem t\u1EA5t c\u1EA3 ",
        /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
          name: "RightOutlined"
        })
      ]
    });
    return renderLink.renderLink(viewMoreUrl, content, isEditingMode);
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: { maxWidth, padding, margin }
  }, rest), {
    maxWidth,
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
      commonStyle: restStyle,
      children: [
        /* @__PURE__ */ jsxRuntime.jsxs(Header, {
          device,
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(StyledTitle, {
              commonStyle: titleStyle,
              children: title
            }),
            !!viewMoreUrl && renderViewAllLink()
          ]
        }),
        /* @__PURE__ */ jsxRuntime.jsx(RecommendBrandWrapper, {
          children: /* @__PURE__ */ jsxRuntime.jsx(Slider.Slider, __spreadProps(__spreadValues({
            allowTouchMove: !isEditingMode
          }, isDesktop ? { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 8 } : { slidesPerView: 1.5, spaceBetween: 16 }), {
            autoplay: !!autoSwipeTimeMilliseconds,
            speed: autoSwipeTimeMilliseconds,
            children: (_c = displayItems == null ? void 0 : displayItems.map) == null ? void 0 : _c.call(displayItems, (item, index) => renderBrandItem(item, index))
          }))
        })
      ]
    })
  }));
};
RecommendBrand.displayName = "Omni_BannerSlider_2";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => getStyles.getStyle(commonStyle)
);
const StyledTitle = styled__default["default"].div(
  ({ commonStyle }) => `
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    ${getStyles.getStyle(commonStyle)}
  `
);
const RecommendBrandWrapper = styled__default["default"].div`
  width: 100%;
  padding: 12px 16px;
`;
const ImageWrapper = styled__default["default"].div`
  width: 100%;
  height: 100%;
`;
const BrandItem = styled__default["default"].div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
`;
const BrandDescription = styled__default["default"].div(
  ({ commonStyle }) => `
  margin-top: 0.5rem;
  font-size: 15px;
  line-height: 20px;
  font-weight: 500;
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  ${getStyles.getStyle(commonStyle)}
`
);
const BrandTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  margin-top: 0.5rem;
  font-size: 15px;
  line-height: 20px;
  font-weight: 500;
  ${getStyles.getStyle(commonStyle)}
`
);
const Header = styled__default["default"](BlockHeader.BlockHeader)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const ViewAll = styled__default["default"].span(
  ({ commonStyle }) => `
    display: flex;
    align-items: center;
    ${getStyles.getStyle(commonStyle)}
  `
);

exports.RecommendBrand = RecommendBrand;


/***/ }),

/***/ 367021:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(327723);
var Container = __webpack_require__(739890);
var BlockHeader = __webpack_require__(177530);
var Slider = __webpack_require__(699332);
var renderLink = __webpack_require__(62534);
var grid = __webpack_require__(793767);
var getStyles = __webpack_require__(523340);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const { cardDefaultImage: defaultImage } = coreRenderer.mappingAssets;
const RecommendCategory = (_a) => {
  var _b = _a, {
    isEditingMode = false,
    maxWidth
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "maxWidth"
  ]);
  const { device } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), {
    title,
    items,
    commonStyle,
    altStyle,
    titleStyle,
    autoSwipeTimeMilliseconds
  } = _a2, rest = __objRest(_a2, [
    "title",
    "items",
    "commonStyle",
    "altStyle",
    "titleStyle",
    "autoSwipeTimeMilliseconds"
  ]);
  const { displayItems } = coreRenderer.useTimeVisibility(items, isEditingMode);
  if (!(displayItems == null ? void 0 : displayItems.length) && !isEditingMode)
    return null;
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: { maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH, padding, margin }
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
      commonStyle: restStyle,
      children: [
        !!title && /* @__PURE__ */ jsxRuntime.jsx(BlockHeader.BlockHeader, {
          device,
          children: /* @__PURE__ */ jsxRuntime.jsx(StyledTitle, {
            commonStyle: titleStyle,
            children: title
          })
        }),
        /* @__PURE__ */ jsxRuntime.jsx(CategoryWrapper, {
          children: /* @__PURE__ */ jsxRuntime.jsx(Slider.Slider, __spreadProps(__spreadValues({
            allowTouchMove: !isEditingMode
          }, device === "desktop" ? { slidesPerView: 6, slidesPerGroup: 6, spaceBetween: 24 } : {
            slidesPerView: 2.5,
            slidesPerColumn: 2,
            spaceBetween: 16,
            isMultipleRows: true
          }), {
            autoplay: !!autoSwipeTimeMilliseconds,
            speed: autoSwipeTimeMilliseconds,
            children: displayItems == null ? void 0 : displayItems.map(({ src, event, alt }, index) => {
              const content = /* @__PURE__ */ jsxRuntime.jsxs(CategoryItem, __spreadProps(__spreadValues({}, !isEditingMode && coreRenderer.getTrackingData({
                isTrackContent: true,
                regionName: "topCategories",
                contentName: title,
                target: coreRenderer.getTargetOfTrackingFromEvent(event),
                index
              })), {
                children: [
                  /* @__PURE__ */ jsxRuntime.jsx(StyledImage, {
                    src: src || defaultImage,
                    alt: alt || "Image",
                    commonStyle: {
                      borderRadius: 12,
                      objectFit: "contain",
                      width: "100%"
                    }
                  }),
                  !!alt && /* @__PURE__ */ jsxRuntime.jsx(CategoryTitle, {
                    commonStyle: altStyle,
                    children: alt
                  })
                ]
              }), index);
              return renderLink.renderLink(event, content, isEditingMode, index);
            })
          }))
        })
      ]
    })
  }));
};
RecommendCategory.displayName = "Omni_RecommendCategory";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => getStyles.getStyle(commonStyle)
);
const StyledTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  transition: color 0.3s ease 0s;
  ${getStyles.getStyle(commonStyle)}
`
);
const CategoryWrapper = styled__default["default"].div`
  padding: 12px 16px;
`;
const CategoryItem = styled__default["default"].div`
  flex-direction: column;
  position: relative;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
`;
const StyledImage = styled__default["default"](coreRenderer.ImageBase)`
  border-radius: 12px;
  box-shadow: rgb(217 217 217) 0px 4px 8px 0px;
`;
const CategoryTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  font-size: 13px;
  line-height: 20px;
  overflow: hidden;
  -webkit-box-orient: vertical;
  transition: color 0.3s ease 0s;
  z-index: 1;
  background-color: white;
  padding: 3px 10px;
  border-radius: 12px;
  max-width: 90%;
  box-shadow: rgb(217 217 217) 0px 4px 8px 0px;
  position: absolute;
  bottom: 0;
  transform: translateY(50%);
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  font-weight: 400;
  ${getStyles.getStyle(commonStyle)}
`
);

exports.RecommendCategory = RecommendCategory;


/***/ }),

/***/ 47120:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(327723);
var antd = __webpack_require__(547728);
var image = __webpack_require__(698791);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const RecommendProductItem = (props) => {
  const { src: imageUrl, buttonTitle, onClick, title } = props;
  const { device } = coreRenderer.useStore();
  const isMobile = device === "mobile";
  const imageDefault = image.generatePlaceholderImage({
    width: isMobile ? 140 : 224,
    height: isMobile ? 180 : 290
  });
  const width = isMobile ? 140 : 224;
  const imageHeight = isMobile ? 180 : 290;
  const fontSizeLabel = isMobile ? 12 : 13;
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
    width,
    children: [
      /* @__PURE__ */ jsxRuntime.jsxs(ImageWrapper, {
        height: imageHeight,
        children: [
          /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, {
            commonStyle: {
              width: "100%",
              objectFit: "cover",
              marginLeft: "auto",
              marginRight: "auto",
              height: isMobile ? "180px" : "290px"
            },
            src: imageUrl || imageDefault
          }),
          !!title && /* @__PURE__ */ jsxRuntime.jsx(LabelWrapper, {
            children: /* @__PURE__ */ jsxRuntime.jsx(Label, {
              fontSize: fontSizeLabel,
              ellipsis: true,
              children: title
            })
          })
        ]
      }),
      /* @__PURE__ */ jsxRuntime.jsx(WrapperButton, {
        children: /* @__PURE__ */ jsxRuntime.jsx(StyledButton, {
          onClick,
          children: /* @__PURE__ */ jsxRuntime.jsx(ClampText, {
            children: buttonTitle
          })
        })
      })
    ]
  });
};
const ImageWrapper = styled__default["default"].div(
  ({ height }) => `
  width: 100%;
  position: relative;
  height: ${height}px;
`
);
const Label = styled__default["default"](antd.Typography.Text)(
  ({ fontSize }) => `
  font-size: ${fontSize}px;
  color: white;
  font-weight: 400;
  padding-left: 4px;
  white-space: nowrap;
`
);
const LabelWrapper = styled__default["default"].div`
  background: #000000b2;
  position: absolute;
  bottom: 4px;
  height: 28px !important;
  width: calc(100% - 12px);
  margin-left: 8px;
  margin-right: 8px;
  border-radius: 8px;
  line-height: 28px;
  display: flex;
  align-items: center;
`;
const Wrapper = styled__default["default"].div(
  ({ width }) => `
  position: relative;
  overflow: clip;
  width: ${width}px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px;
`
);
const WrapperButton = styled__default["default"].div`
  padding: 8px;
  width: 100%;
`;
const StyledButton = styled__default["default"].div`
  font-size: 13px;
  font-weight: '400';
  width: 100%;
  cursor: pointer;
  background: #0200bc;
  color: #ffffff;
  border-radius: 9999px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  word-wrap: break-word;
  padding: 8px;
  text-align: center;
  white-space: break-spaces;
`;
const ClampText = styled__default["default"].p`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

exports.RecommendProductItem = RecommendProductItem;


/***/ }),

/***/ 526726:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const RecommendProductTabs = (props) => {
  const { items, activeItem, onChange, activeTabColor } = props;
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    children: /* @__PURE__ */ jsxRuntime.jsx(TabList, {
      children: items == null ? void 0 : items.map((item) => {
        return /* @__PURE__ */ jsxRuntime.jsx(WrapperItem, {
          onClick: () => onChange(item.id),
          children: /* @__PURE__ */ jsxRuntime.jsx(StyledTabbar, {
            activeTabColor,
            isActive: item.id === activeItem.id,
            children: item.title
          }, item.id)
        });
      })
    })
  });
};
const Wrapper = styled__default["default"].div`
  width: 100%;
  border-bottom: 1px solid #e5e5e5;
  overflow-x: auto;
  white-space: nowrap;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
  margin-bottom: 16px;
`;
const TabList = styled__default["default"].div`
  display: flex;
`;
const StyledTabbar = styled__default["default"].div(
  ({ isActive, activeTabColor }) => `
  padding-top: 12px;
  padding-bottom: 12px;
  ${isActive ? `border-bottom: 2px solid ${activeTabColor};` : ""}
  ${isActive ? `color: ${activeTabColor};` : ""}
  font-weight: 400;
  font-size: 14px;
`
);
const WrapperItem = styled__default["default"].div`
  padding-right: 32px;
  cursor: pointer;
`;

exports.RecommendProductTabs = RecommendProductTabs;


/***/ }),

/***/ 249968:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var uuid = __webpack_require__(596839);
var style = __webpack_require__(629909);
var grid = __webpack_require__(793767);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const defaultProductGroupItem = {
  title: "Nguy\xEAn li\u1EC7u ch\xEDnh",
  productSkus: ""
};
const defaultGroup = [
  {
    imageUrl: "https://lh3.googleusercontent.com/KlpDRUo6wrfd2zgWBfyLdA8dyWpUkMdYxZYUtMuMihjkVoAOhS5KYhVWLj80BoKaFBBCEPiRIR8HTOQE2tAjXP9zNuULoMvU",
    productGroups: [defaultProductGroupItem, defaultProductGroupItem]
  },
  {
    imageUrl: "https://lh3.googleusercontent.com/mrJaG0cJe9Yt_MgEZKs5hXJvaJvgchGFXN2PN0DU4oMqCywFfXBeIPRdt7CQF9Kl3X2khbh6KZwx6qvmHTIRu5eaDmKFizY0",
    productGroups: [defaultProductGroupItem, defaultProductGroupItem]
  },
  {
    imageUrl: "https://lh3.googleusercontent.com/qUXZ145LXwYy320wuf8wEKsrEOIZgZjGmu4dQmKqhd9wVckhCdHMhyQICNNYRG7j26juXgrWQprkYsYqKpB5PZ849dA7fw8V",
    productGroups: [defaultProductGroupItem, defaultProductGroupItem]
  },
  {
    imageUrl: "https://lh3.googleusercontent.com/TSevtOCIrghz0P7UnRBco_3uxMvapwhzp56_SzTl808vAOrNCiB6fJKdOhoi1h4gcePtThnLP3upG6U4RGOSQLY95iMp6xNr",
    productGroups: [defaultProductGroupItem, defaultProductGroupItem]
  },
  {
    imageUrl: "https://lh3.googleusercontent.com/KlpDRUo6wrfd2zgWBfyLdA8dyWpUkMdYxZYUtMuMihjkVoAOhS5KYhVWLj80BoKaFBBCEPiRIR8HTOQE2tAjXP9zNuULoMvU",
    productGroups: [defaultProductGroupItem, defaultProductGroupItem]
  }
];
const DEFAULT_RECOMMEND_PRODUCT_ITEMS_DATA = {
  items: [
    {
      id: uuid.v4(),
      title: "M\xF3n chi\xEAn-x\xE0o",
      groups: defaultGroup
    },
    {
      id: uuid.v4(),
      title: "M\xF3n h\u1EA5p",
      groups: defaultGroup
    },
    {
      id: uuid.v4(),
      title: "M\xF3n lu\u1ED9c",
      groups: defaultGroup
    },
    {
      id: uuid.v4(),
      title: "M\xF3n n\u01B0\u1EDBng",
      groups: defaultGroup
    },
    {
      id: uuid.v4(),
      title: "T\u1ED1i \u1EA5m c\xFAng",
      groups: defaultGroup
    },
    {
      id: uuid.v4(),
      title: "S\xE1ng t\u1EC9nh t\xE1o",
      groups: defaultGroup
    }
  ]
};
const DEFAULT_RECOMMEND_PRODUCT = __spreadProps(__spreadValues({
  syncDeviceStyle: true,
  title: "KH\xC1M PH\xC1 M\xD3N NGON",
  buttonTitle: "Mua nguy\xEAn li\u1EC7u",
  radius: "16",
  maxWidth: grid.DEFAULT_MAX_WIDTH
}, DEFAULT_RECOMMEND_PRODUCT_ITEMS_DATA), {
  desktop: {
    commonStyle: __spreadProps(__spreadValues({}, style.DESKTOP_COMMON_STYLE), {
      padding: {
        left: 16,
        right: 16,
        top: 16,
        bottom: 16
      }
    }),
    titleStyle: {
      color: "#000000"
    },
    tabStyle: {
      activeTabStyle: "#1677FF"
    },
    backgroundColor: "#ffffff"
  },
  mobile: {
    commonStyle: __spreadProps(__spreadValues({}, style.MOBILE_COMMON_STYLE), {
      padding: {
        left: 16,
        right: 16
      }
    }),
    titleStyle: {
      color: "#000000"
    },
    tabStyle: {
      activeTabStyle: "#1677FF",
      backgroundColor: "#ffffff"
    }
  }
});
const RECOMMEND_PRODUCT_DEFAULT_SPACING_DESKTOP = 16;
const RECOMMEND_PRODUCT_DEFAULT_SPACING_MOBILE = 8;
const WIDTH_OF_MODAL_SELECT_PRODUCT = 1020;

exports.DEFAULT_RECOMMEND_PRODUCT = DEFAULT_RECOMMEND_PRODUCT;
exports.RECOMMEND_PRODUCT_DEFAULT_SPACING_DESKTOP = RECOMMEND_PRODUCT_DEFAULT_SPACING_DESKTOP;
exports.RECOMMEND_PRODUCT_DEFAULT_SPACING_MOBILE = RECOMMEND_PRODUCT_DEFAULT_SPACING_MOBILE;
exports.WIDTH_OF_MODAL_SELECT_PRODUCT = WIDTH_OF_MODAL_SELECT_PRODUCT;


/***/ }),

/***/ 517378:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(327723);
var antd = __webpack_require__(547728);
var React = __webpack_require__(891987);
var constants = __webpack_require__(249968);
var RecommendProductTabs = __webpack_require__(526726);
var RecommendProductItem = __webpack_require__(47120);
var Container = __webpack_require__(739890);
var grid = __webpack_require__(793767);
var renderDynamicSlot = __webpack_require__(744175);
var Slider = __webpack_require__(699332);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const RecommendProduct = (props) => {
  var _b, _c, _d, _e;
  const _a = props, {
    title,
    buttonTitle,
    items,
    isEditingMode,
    maxWidth = grid.DEFAULT_MAX_WIDTH,
    radius
  } = _a, restProps = __objRest(_a, [
    "title",
    "buttonTitle",
    "items",
    "isEditingMode",
    "maxWidth",
    "radius"
  ]);
  const { device, mappingDynamicSlots } = coreRenderer.useStore();
  const isMobile = device === "mobile";
  const { commonStyle, backgroundColor, titleStyle, tabStyle } = coreRenderer.getPropsByDevice(restProps, device);
  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);
  const [isShowModalSelectProduct, setIsShowModalSelectProduct] = React.useState(false);
  const [isShowModalSelectProductMobile, setIsShowModalSelectProductMobile] = React.useState(false);
  const { padding, margin } = commonStyle || {};
  const [showNavBtns, setShowNavBtns] = React.useState(false);
  const [activeItem, setActiveItem] = React.useState(
    {}
  );
  const [activeGroup, setActiveGroup] = React.useState({});
  const onChange = (key) => {
    const newActiveItem = (items == null ? void 0 : items.find((item) => item.id === key)) || {};
    setActiveItem(newActiveItem);
  };
  React.useEffect(() => {
    if (!!items && Array.isArray(items)) {
      setActiveItem(items == null ? void 0 : items[0]);
    }
  }, [items]);
  const showModal = () => {
    isMobile ? setIsShowModalSelectProductMobile(true) : setIsShowModalSelectProduct(true);
  };
  const handleCancelModal = () => {
    isMobile ? setIsShowModalSelectProductMobile(false) : setIsShowModalSelectProduct(false);
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, {
    commonStyle: {
      padding,
      margin,
      maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH
    },
    maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH,
    children: /* @__PURE__ */ jsxRuntime.jsxs("div", {
      style: {
        borderRadius: Number(radius),
        backgroundColor,
        padding: 16,
        width: "100%"
      },
      children: [
        title ? /* @__PURE__ */ jsxRuntime.jsx(TitleWrapper, {
          children: /* @__PURE__ */ jsxRuntime.jsx(TitleStyled, {
            fontWeight: isMobile ? 500 : 700,
            fontSize: isMobile ? 16 : 20,
            style: { color: titleStyle.color },
            children: title
          })
        }) : null,
        /* @__PURE__ */ jsxRuntime.jsx(RecommendProductTabs.RecommendProductTabs, {
          onChange,
          items,
          activeItem,
          activeTabColor: tabStyle.activeTabStyle
        }),
        (activeItem == null ? void 0 : activeItem.groups) && /* @__PURE__ */ jsxRuntime.jsx(SliderWrapper, {
          style: { alignItems: (_b = grid.MAPPING_ALIGNMENT_FLEX) == null ? void 0 : _b["center"] },
          children: /* @__PURE__ */ jsxRuntime.jsxs("div", {
            onMouseEnter: () => setShowNavBtns(true),
            onMouseLeave: () => setShowNavBtns(false),
            style: {
              position: "relative",
              width: "100%"
            },
            children: [
              ((_c = activeItem == null ? void 0 : activeItem.groups) == null ? void 0 : _c.length) > 1 && /* @__PURE__ */ jsxRuntime.jsx(NavigationButtonStyled, {
                className: "left-nav",
                style: { opacity: showNavBtns ? 1 : 0 },
                ref: navigationPrevRef
              }),
              /* @__PURE__ */ jsxRuntime.jsx(SliderStyled, {
                navigation: {
                  prevEl: navigationPrevRef.current,
                  nextEl: navigationNextRef.current
                },
                slidesPerView: "auto",
                navigationStyle: 1,
                paginationColor: "#ffffff",
                allowTouchMove: !isEditingMode,
                onBeforeInit: (swiper) => {
                  swiper.params.navigation.prevEl = navigationPrevRef.current;
                  swiper.params.navigation.nextEl = navigationNextRef.current;
                },
                spaceBetween: isMobile ? constants.RECOMMEND_PRODUCT_DEFAULT_SPACING_MOBILE : constants.RECOMMEND_PRODUCT_DEFAULT_SPACING_DESKTOP,
                children: (_d = activeItem == null ? void 0 : activeItem.groups) == null ? void 0 : _d.map((item, index) => /* @__PURE__ */ jsxRuntime.jsx(RecommendProductItem.RecommendProductItem, {
                  src: item.imageUrl,
                  buttonTitle,
                  onClick: () => {
                    showModal();
                    setActiveGroup(item);
                  },
                  title: item.title
                }, `${index}`))
              }),
              ((_e = activeItem == null ? void 0 : activeItem.groups) == null ? void 0 : _e.length) > 1 && /* @__PURE__ */ jsxRuntime.jsx(NavigationButtonStyled, {
                className: "right-nav",
                style: { opacity: showNavBtns ? 1 : 0 },
                ref: navigationNextRef
              })
            ]
          })
        }),
        isMobile ? /* @__PURE__ */ jsxRuntime.jsx(antd.Drawer, {
          placement: "bottom",
          closable: false,
          open: isShowModalSelectProductMobile,
          onClose: handleCancelModal,
          size: "large",
          style: { borderTopLeftRadius: "8px", borderTopRightRadius: "8px" },
          bodyStyle: {
            padding: 0
          },
          height: "90%",
          children: renderDynamicSlot.renderDynamicSlot(
            `modal_recommend_product`,
            mappingDynamicSlots,
            void 0,
            {
              activeGroup,
              config: { maxWidth },
              onCloseModal: () => setIsShowModalSelectProductMobile(false)
            }
          )
        }) : /* @__PURE__ */ jsxRuntime.jsx(antd.Modal, {
          open: isShowModalSelectProduct,
          onCancel: handleCancelModal,
          width: constants.WIDTH_OF_MODAL_SELECT_PRODUCT,
          footer: [],
          closable: false,
          centered: true,
          zIndex: 1050,
          children: renderDynamicSlot.renderDynamicSlot(
            `modal_recommend_product`,
            mappingDynamicSlots,
            void 0,
            {
              activeGroup,
              config: { maxWidth },
              onCloseModal: () => setIsShowModalSelectProduct(false)
            }
          )
        })
      ]
    })
  });
};
RecommendProduct.displayName = "Omni_RecommendProduct";
const TitleWrapper = styled__default["default"].div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  @media (max-width: 460px) {
    margin-bottom: 12px;
  }
`;
const TitleStyled = styled__default["default"].div(
  ({ fontSize, fontWeight }) => `
  font-size: ${fontSize}px;
  font-weight: ${fontWeight};
  line-height: 28px;
  margin: 0 16px 0 0;
`
);
const SliderWrapper = styled__default["default"].div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const NavigationButtonStyled = styled__default["default"].div`
  top: 50%;
  position: absolute;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 100px;
  background-color: white;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.2);
  &:after {
    content: ' ';
    height: 30px;
    width: 30px;
    display: inline-block;
    background: #333;
  }

  &.left-nav {
    transform: translateY(-50%) translateX(-50%);
    left: 0px;

    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
      mask-size: contain;
    }
  }

  &.right-nav {
    transform: translateY(-50%) translateX(50%);
    right: 0px;

    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
      mask-size: contain;
    }
  }

  &.swiper-button-disabled {
    display: none;
  }
`;
const SliderStyled = styled__default["default"](Slider.Slider)(
  () => `
   .swiper-wrapper {
    display: grid;
    grid-auto-flow: column;
    width: fit-content;
    row-gap: 4px;
  }

  .swiper-slide {
    display: grid;
    grid-template-rows: subgrid;
  }

`
);

exports.RecommendProduct = RecommendProduct;


/***/ })

}]);